import { Button, ButtonGroup, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => {
  return {
    outlinedPrimary: {
      background: theme.palette.background.paper,
    },
  }
})

const CurrentUpcomingAppCycleToggle = ({
  hasCurrentFocus,
  onChangeCycleFocus,
}: {
  hasCurrentFocus: boolean
  onChangeCycleFocus: (isFocused: boolean) => void
}) => {
  const classes = useStyles()
  return (
    <>
      <Typography
        variant="srOnly"
        id="toggle-upcoming-current-aria"
      >
        toggle upcoming or current application cycle
      </Typography>
      <ButtonGroup
        color="primary"
        fullWidth
      >
        <Button
          variant={hasCurrentFocus ? 'outlined' : 'contained'}
          onClick={!hasCurrentFocus ? undefined : () => onChangeCycleFocus(false)}
          classes={{ outlinedPrimary: classes.outlinedPrimary }}
          aria-describedby="toggle-upcoming-current-aria"
        >
          Upcoming
        </Button>
        <Button
          variant={hasCurrentFocus ? 'contained' : 'outlined'}
          onClick={hasCurrentFocus ? undefined : () => onChangeCycleFocus(true)}
          classes={{ outlinedPrimary: classes.outlinedPrimary }}
          aria-describedby="toggle-upcoming-current-aria"
        >
          Current
        </Button>
      </ButtonGroup>
    </>
  )
}

export default CurrentUpcomingAppCycleToggle
